import React from "react"

import { GridDiagramCell, GridDiagramCellProps } from "./GridDiagramCell"
import { GridDiagramCellInfo } from "./GridDiagramCellInfo"
import { GridDiagramRow } from "./GridDiagramRow"
import { FlexLayout } from "../layout/flex/FlexLayout"
import { TestProps } from "../helpers/TestProps"
import { renderTestID } from "../helpers/renderTestID"
import { Size } from "../helpers/parseSize"

export interface BaseGridDiagramCell
  extends Omit<GridDiagramCellProps, "translator" | "layoutSize" > { }

type BaseGridDiagramRow = "spacer" | { cols: BaseGridDiagramColumn[] }
type BaseGridDiagramColumn = "spacer" | BaseGridDiagramCell

export interface BaseGridDiagramProps extends TestProps {

  grid: GridDiagramRow[],

  buildCell: (cell: GridDiagramCellInfo) => BaseGridDiagramCell

  spacingSize?: Size
}

/**
 * Renders a grid of cells.
 */
export class BaseGridDiagram extends React.PureComponent<BaseGridDiagramProps> {

  public render() {

    const {
      grid,
      buildCell,
      testID,
      spacingSize = "sm"
    } = this.props

    const {
      rows,
      cols,
    } = { rows: grid.length, cols: grid[0].cells.length }

    const gridRows: BaseGridDiagramRow[] = []

    for (let row = 0; row < rows; row++) {
      const gridColumns: BaseGridDiagramColumn[] = []

      for (let col = 0; col < cols; col++) {

        gridColumns.push(buildCell(grid[row].cells[col]))

        if (col < (cols - 1)) {
          gridColumns.push("spacer")
        }
      }

      gridRows.push({
        cols: gridColumns
      })

      if (row < (rows - 1)) {
        gridRows.push("spacer")
      }
    }

    return (
      <FlexLayout direction="column" testID={renderTestID(testID)}>
        {gridRows.map((row, rowInd) => (
          (row === "spacer" ? (
            <FlexLayout.Spacer
              key={"row_spacer_" + rowInd}
              size={spacingSize}
            />
          ) : (
            <FlexLayout.Item key={"row_" + rowInd}>
              <FlexLayout direction="row">
                {row.cols.map((col, colInd) => (
                  (col === "spacer" ? (
                    <FlexLayout.Spacer
                      key={"col_spacer_" + colInd}
                      size={spacingSize}
                    />
                  ) : (
                    <FlexLayout.Item key={"col_" + colInd}>
                      <GridDiagramCell
                        {...col}
                      />
                    </FlexLayout.Item>
                  ))
                ))}
              </FlexLayout>
            </FlexLayout.Item>
          ))
        ))}
      </FlexLayout>
    )
  }
}
